<template>
  <div>
    <el-input class="select-input" v-model="value" clearable :placeholder="placeholder" :disabled="disabled">
      <el-button slot="append" class="select-btn" v-if="!disabled" @click="dialogOpen = true">选择</el-button>
    </el-input>
    <el-dialog
      :visible.sync="dialogOpen"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
      append-to-body
      class="select-mater"
      width="80%"
    >
      <div slot="title" class="select-mater-title">
        <span>选择落地页</span>
      </div>
      <div class="dialog-search-header">
        <div>
          <el-form :model="searchForm" ref="searchForm" :inline="true" label-width="117px" label-position="left" size="small">
            <el-form-item>
              <el-input
                placeholder="输入落地页名称搜索"
                v-model="searchForm.landingPageName"
                v-noEmoji class="form-input"
                @change="fetchData"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="timeList"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                @change="getUploadTime"
                class="form-picker"
              ></el-date-picker>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <span style="font-size: 24px;cursor: pointer" @click="isShowGrid = !isShowGrid">
            <i :class="isShowGrid ? 'el-icon-s-fold' : 'el-icon-s-grid '"></i>
          </span>
        </div>
      </div>
      <Table
        :props="table.props"
        :header="table.header"
        :data="table.data"
        :selection-type="table.selectionType"
        v-if="!isShowGrid"
        v-loading="tableLoading"
      />
      <template v-if="isShowGrid">
        <template v-if="gridTable.data.length === 0 && !cardLoading">
          <div class="img-list-none">暂无数据</div>
        </template>
        <template v-else>
          <CardList
            class="img-list"
            :data="gridTable.data"
            :selection-type="gridTable.selectionType"
            v-loading="cardLoading"
          >
            <div class="img-item" slot="row" slot-scope="{ row: item }">
              <div class="img-item-box">
                <img referrerpolicy="no-referrer" :key="item.landingPageIcon" :src="item.landingPageIcon" />
              </div>
              <div class="img-title">{{ item.landingPageName }}</div>
              <div class="img-detail">
                <el-button @click="handleRowSelectionChange(item)">选择</el-button>
              </div>
            </div>
          </CardList>
        </template>
      </template>
      <el-pagination :total="totalCount" :current-page="currentPage" @current-change="handleCurrentChange" layout="prev, pager, next"></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import { Table, CardList } from '@ccprivate/admin-toolkit'

export default {
  components: {
    Table,
    CardList
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    partnerId: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tableLoading: false,
      cardLoading: false,
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        order: 'desc',
        sort: 'landingPageId',
        landingPageName: undefined,
        startDateX: undefined,
        endDateX: undefined
      },
      timeList: [],
      isShowGrid: true,
      pageSize: 10,
      // 当前页码:pageNum
      currentPage: 1,
      totalCount: 1,
      table: {
        props: {
          height: 358,
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '缩略图',
            align: 'center',
            prop: 'landingPageIcon',
            'min-width': 80,
            isShow: true,
            render: (h, { row }) => {
              return h('el-image', {
                attrs: {
                  src: row.landingPageIcon
                },
                style: {
                  width: '100px',
                  height: '59px'
                }
              })
            }
          },
          {
            label: '落地页名称',
            align: 'left',
            prop: 'landingPageName',
            'min-width': 160,
            'show-overflow-tooltip': true
          },
          {
            label: '落地页类型',
            align: 'left',
            prop: 'landingPageClass.landingPageClassName',
            'min-width': 80,
            'show-overflow-tooltip': true
          },
          {
            label: '时长',
            align: 'left',
            prop: 'duration',
            'min-width': 120,
            isShow: true,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return `${row.duration} S`
            }
          },
          {
            label: '创建时间',
            align: 'left',
            prop: 'createTime',
            'min-width': 160,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return this.$moment(row.createTime).format('YYYY-MM-DD HH:mm:ss')
            }
          },
          {
            label: '操作栏',
            'min-width': 120,
            align: 'left',
            render: (h, { row }) => {
              return h('div', [
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text'
                    },
                    on: {
                      click: (event) => {
                        event.stopPropagation()
                        this.handleRowSelectionChange(row)
                      }
                    }
                  },
                  '选择'
                )
              ])
            }
          }
        ],
        data: []
      },
      gridTable: {
        props: {},
        data: []
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      },
      dialogOpen: false
    }
  },
  methods: {
    handleOpenDialog() {
      if (this.isShowGrid) {
        this.cardLoading = true
      } else {
        this.tableLoading = true
      }
      this.fetchData()
    },
    fetchData() {
      const params = this.searchForm
      if (this.partnerId) {
        params.partnerId = this.partnerId
      }
      params.transcodeStatus = 0
      this.$service
        .getLandingPageList(params)
        .then((data) => {
          this.totalCount = data.total
          this.gridTable.data = data.rows
          this.table.data = data.rows
          this.cardLoading = false
          this.tableLoading = false
        })
        .catch(() => {
          this.cardLoading = false
          this.tableLoading = false
        })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.searchForm.pageNo = val
      this.fetchData()
    },
    getUploadTime() {
      if (this.timeList) {
        this.searchForm.startDateX = this.$moment(this.timeList[0]).format(
          'YYYY-MM-DD 00:00:00'
        )
        this.searchForm.endDateX = this.$moment(this.timeList[1]).format(
          'YYYY-MM-DD 23:59:59'
        )
      } else {
        this.searchForm.startDateX = ''
        this.searchForm.endDateX = ''
      }
      this.fetchData()
    },
    handleRowSelectionChange(row) {
      this.dialogOpen = false
      this.$emit('selected', row)
    }
  },
  created() {
    if (!this.disabled) {
      this.fetchData()
    }
  }
}
</script>
<style lang="stylus" scoped>
.select-mater >>> .el-dialog__body
  padding 16px 40px
.dialog-search-header
  display flex
  flex-direction row
  justify-content space-between
/* *素材库选择器样式 */
.img-list-none
  width 100%
  display flex
  flex-direction row
  justify-content center
  align-items center
  color #909399
.img-list
  width 100%
  display flex
  flex-direction row
  height 392px
.img-list
  >>>.el-row
    width 100%
    margin 0 !important
>>>.card-item-wrapper
  width 19.1%
  margin-right 9px
  margin-bottom 9px
  padding 0px !important
  // margin-right 9px
  height 185px
  background rgba(255, 255, 255, 1)
  border-radius 2px
  border 1px solid rgba(233, 233, 233, 1)
.img-list>>>.card-item-wrapper:nth-child(5n+5)
  margin-right 0
.img-item
  .img-item-box
    height 116px
  img
    width 100%
    max-height 100%
  .img-detail
    position absolute
    top 0
    text-align center
    background rgba(8, 8, 8, 0.5)
    width 100%
    display none
    height inherit
    line-height 185px
    .detail-button
      margin-top -50px
      top 50%
      position relative
    span
      display block
  &:hover
    .img-detail
      display block
  .img-info
    font-size 12px
    padding 0px 8px 8px
  .img-title
    height 40px
    line-height 20px
    padding 8px 8px 0px 8px
    position relative
    text-overflow ellipsis
    overflow hidden
    display -moz-box
    -moz-line-clamp 2 !important
    -moz-box-orient vertical
    /* autoprefixer: off */
    display -webkit-box
    -webkit-line-clamp 2
    -webkit-box-orient vertical
  .img-status
    float right
  .img-preview
    position absolute
    top 0
    right 0
    cursor pointer
    height 20px
    color #444
    background #fff
    padding 0px 5px
.table-header-button.is-disabled, .table-header-button.is-disabled:hover
  color #D8D8D8
  color #D8D8D8
.table-header-button
  color #666
  border none !important
>>>.el-form-item
  margin-bottom 16px
.select-mater-title
  padding 0
>>>.el-dialog__header
  padding 16px 24px
  border-bottom 1px solid rgba(0, 0, 0, 0.09)
.select-mater-title span
  width 64px
  height 24px
  font-size 16px
  font-weight 500
  color rgba(0, 0, 0, 0.85)
  line-height 24px
.form-input, .form-picker, .form-select
  width 220px
.form-picker
  margin-left auto
  >>>.el-range-editor.el-input__inner
    width 220px
  >>>.el-input__inner
    color rgba(0, 0, 0, 0.65)
>>>.el-input-group__prepend, >>>.el-input-group__append
    background-color #fff
    color #606266
</style>
